/**
 * Diccionario i18n del módulo LotoWheel (sorteos de la rueda de la fortuna).
 * Cubre lotowheel.js y lotowheel-modal-apariencia.js.
 *
 * Clave = texto español EXACTO tal cual aparece en el código (estilo gettext).
 * Solo columna pt (Fase 1). Los literales globales (Guardar, Cancelar, Activo,
 * Inactivo, Editar, Default, Heredar…) ya viven en diccionario-comunes.js
 * y NO se re-declaran acá.
 *
 * Terminología pt-BR canónica: sorteio, aposta, roda (da fortuna), giro,
 * Duo/Trio/Quarteto/Sexteto/Gêmeos. NUNCA "roleta" para lo nuestro — es roda.
 */

export const DICCIONARIO_LOTOWHEEL = {
    // ── Cards de la lista ───────────────────────────────────────────────────
    'Sin algoritmo matemático': { pt: 'Sem algoritmo matemático', en: 'No mathematical algorithm', ru: 'Без математического алгоритма' },
    'Consultando sorteos y estado del scheduler…': {
        pt: 'Consultando sorteios e estado do scheduler…',
        en: 'Fetching draws and scheduler status…',
        ru: 'Загрузка тиражей и состояния планировщика…',
    },
    // Global → ya en diccionario-marketing.js — no re-declarar
    'Intervalo:': { pt: 'Intervalo:', en: 'Interval:', ru: 'Интервал:' },

    // ── Estado del scheduler en la card ────────────────────────────────────
    '▶ corriendo': { pt: '▶ em execução', en: '▶ running', ru: '▶ выполняется' },
    '■ scheduler detenido': { pt: '■ agendador parado', en: '■ scheduler stopped', ru: '■ планировщик остановлен' },
    '⚠ estado scheduler desconocido': { pt: '⚠ estado do agendador desconhecido', en: '⚠ unknown scheduler state', ru: '⚠ состояние планировщика неизвестно' },
    '⚠ divergente': { pt: '⚠ divergente', en: '⚠ divergent', ru: '⚠ расхождение' },
    '⚠ divergente DB↔RAM': { pt: '⚠ divergente DB↔RAM', en: '⚠ divergent DB↔RAM', ru: '⚠ расхождение DB↔RAM' },
    'próximo en': { pt: 'próximo em', en: 'next in', ru: 'следующий через' },

    // ── Modal principal — títulos y permisos ────────────────────────────────
    'Editar LotoWheel': { pt: 'Editar LotoWheel', en: 'Edit LotoWheel', ru: 'Редактировать LotoWheel' },
    'Nuevo LotoWheel': { pt: 'Novo LotoWheel', en: 'New LotoWheel', ru: 'Новый LotoWheel' },
    'Cargando configuración del sorteo...': { pt: 'Carregando configuração do sorteio...', en: 'Loading draw configuration...', ru: 'Загрузка конфигурации розыгрыша...' },
    'Solo superadmin puede editar sorteos globales': {
        pt: 'Apenas o superadmin pode editar sorteios globais',
        en: 'Only superadmin can edit global draws',
        ru: 'Только суперадмин может редактировать глобальные розыгрыши',
    },

    // ── Toast de guardado ───────────────────────────────────────────────────
    '· Aplicado al scheduler.': { pt: '· Aplicado ao agendador.', en: '· Applied to the scheduler.', ru: '· Применено к планировщику.' },

    // ── Confirm de eliminación ──────────────────────────────────────────────
    '¿Eliminar "': { pt: 'Excluir "', en: 'Delete "', ru: 'Удалить "' },
    'y todos sus resultados?': { pt: 'e todos os seus resultados?', en: 'and all its results?', ru: 'и все его результаты?' },
    'ATENCIÓN —': { pt: 'ATENÇÃO —', en: 'WARNING —', ru: 'ВНИМАНИЕ —' },
    'Si elimina ahora los clientes PERDERÁN las jugadas restantes ya pagadas. Debe gestionar el reembolso manual.': {
        pt: 'Se excluir agora os clientes PERDERÃO as jogadas restantes já pagas. Você deve gerenciar o reembolso manualmente.',
        en: 'If you delete now, customers will LOSE the remaining plays already paid. You must handle the refund manually.',
        ru: 'Если удалить сейчас, клиенты ПОТЕРЯЮТ оставшиеся уже оплаченные ставки. Возврат средств нужно оформить вручную.',
    },
    '¿Continuar con la eliminación FORZADA?': { pt: 'Continuar com a exclusão FORÇADA?', en: 'Continue with FORCED deletion?', ru: 'Продолжить ПРИНУДИТЕЛЬНОЕ удаление?' },
    'Tickets afectados:': { pt: 'Tickets afetados:', en: 'Affected tickets:', ru: 'Затронутые билеты:' },
    'y': { pt: 'e', en: 'and', ru: 'и' },
    'más': { pt: 'mais', en: 'more', ru: 'ещё' },
    'Eliminación cancelada. El sorteo sigue activo.': {
        pt: 'Exclusão cancelada. O sorteio continua ativo.',
        en: 'Deletion cancelled. The draw is still active.',
        ru: 'Удаление отменено. Розыгрыш всё ещё активен.',
    },
    'LotoWheel eliminado (forzado con bearer huérfanos)': {
        pt: 'LotoWheel excluído (forçado com bearer órfãos)',
        en: 'LotoWheel deleted (forced with orphan bearers)',
        ru: 'LotoWheel удалён (принудительно, с осиротевшими bearer)',
    },
    'LotoWheel eliminado': { pt: 'LotoWheel excluído', en: 'LotoWheel deleted', ru: 'LotoWheel удалён' },

    // ── Series de tickets ───────────────────────────────────────────────────
    // Heredar: ya en diccionario-nodos.js → no re-declarar
    '(global)': { pt: '(global)', en: '(global)', ru: '(глобальный)' },

    // ── Panel info del tipo de rueda ────────────────────────────────────────
    Configuracion: { pt: 'Configuração', en: 'Configuration', ru: 'Конфигурация' },
    'Tercios:': { pt: 'Terços:', en: 'Thirds:', ru: 'Трети:' },
    'Mitad:': { pt: 'Metade:', en: 'Half:', ru: 'Половина:' },
    Pleno: { pt: 'Pleno', en: 'Straight', ru: 'Полное' },
    'Especiales:': { pt: 'Especiais:', en: 'Specials:', ru: 'Специальные:' },
    'No disponible:': { pt: 'Não disponível:', en: 'Not available:', ru: 'Недоступно:' },
    'Ciclo pleno': { pt: 'Ciclo pleno', en: 'Straight cycle', ru: 'Полный цикл' },
    'Ciclo mitad': { pt: 'Ciclo metade', en: 'Half cycle', ru: 'Цикл по половине' },
    'Ciclo bloque': { pt: 'Ciclo bloco', en: 'Block cycle', ru: 'Цикл по блоку' },
    '~1 cada': { pt: '~1 a cada', en: '~1 every', ru: '~1 на каждые' },
    tiradas: { pt: 'rodadas', en: 'spins', ru: 'вращений' },
    'Volatilidad base:': { pt: 'Volatilidade base:', en: 'Base volatility:', ru: 'Базовая волатильность:' },
    'referencia sin ponderación; el RTP real lo determina el algoritmo': {
        pt: 'referência sem ponderação; o RTP real é determinado pelo algoritmo',
        en: 'unweighted reference; the actual RTP is determined by the algorithm',
        ru: 'справочно без взвешивания; реальный RTP определяет алгоритм',
    },
    'Alta (premios poco frecuentes)': { pt: 'Alta (prêmios pouco frequentes)', en: 'High (infrequent prizes)', ru: 'Высокая (редкие выигрыши)' },
    Media: { pt: 'Média', en: 'Medium', ru: 'Средняя' },
    'Baja (premios frecuentes)': { pt: 'Baixa (prêmios frequentes)', en: 'Low (frequent prizes)', ru: 'Низкая (частые выигрыши)' },

    // ── Branding ────────────────────────────────────────────────────────────
    'Error: no se encontró el ID del sorteo': { pt: 'Erro: ID do sorteio não encontrado', en: 'Error: draw ID not found', ru: 'Ошибка: ID розыгрыша не найден' },
    // Personalizado → ya en diccionario-nodos.js (pt: 'Personalizado') — no re-declarar
    // Default      → ya en diccionario-nodos.js (pt: 'Padrão')         — no re-declarar

    // ── Apuestas — nombres de grupo ─────────────────────────────────────────
    // Cuarteto → ya en diccionario-nodos.js (pt: 'Quarteto') — no re-declarar
    // Sexteto  → ya en diccionario-nodos.js (pt: 'Sexteto')  — no re-declarar
    Duo: { pt: 'Duo', en: 'Duo', ru: 'Дуо' },
    Trio: { pt: 'Trio', en: 'Trio', ru: 'Трио' },
    Bloque: { pt: 'Bloco', en: 'Block', ru: 'Блок' },
    'Espejos x': { pt: 'Espelhos x', en: 'Mirrors x', ru: 'Зеркала x' },
    'Gemelos x': { pt: 'Gêmeos x', en: 'Twins x', ru: 'Близнецы x' },

    // ── Apuestas — panel de disponibilidad ─────────────────────────────────
    columnas: { pt: 'colunas', en: 'columns', ru: 'столбцы' },
    bloques: { pt: 'blocos', en: 'blocks', ru: 'блоки' },
};
